import React, { FC } from 'react';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import { WebsiteEditorMediaGalleryComponentFragment } from '@graphql/generated';
import { PhotoGalleryAddEditProps } from '../../PhotoGallery.types';
import { WebsiteEditorPhotoGalleryTelemetryProvider } from '../../PhotoGallery.telemetry';
import { SelectPhotoGallery } from '../../components';

export const PhotoGalleryAddEdit: FC<PhotoGalleryAddEditProps> = props => {
  const { customComponentBlockData: photoGalleryData } = useCustomComponentStateContext<WebsiteEditorMediaGalleryComponentFragment>();

  return (
    <WebsiteEditorPhotoGalleryTelemetryProvider>
      <SelectPhotoGallery
        {...props}
        photoGalleryData={photoGalleryData}
      />
    </WebsiteEditorPhotoGalleryTelemetryProvider>
  );
};

PhotoGalleryAddEdit.displayName = 'PhotoGalleryAddEdit';
